import styled from 'styled-components'

export const StyledCompanyLogo = styled.img`
    width: ${props => props.default ? '60%' : '100%'};
    height: ${props => props.activated ? 'auto' : '100%'};
    border-radius: 20px;
`